import { store } from '../../store';
import { updateMessageStatus, updateThinkingStatus } from '../../store/chat/slice';
import { MessageStatus } from '../../store/chat/types';
import { SocketMessage } from '../types';

export interface MessageStatusPayload {
  conversationId: string;
  messageSequence: number;
  status: MessageStatus;
}

/**
 * Handler for message status updates received via websocket
 * Updates the message status in Redux
 */
export function messageStatusHandler(message: SocketMessage<MessageStatusPayload>): void {
  const payload = message.payload as MessageStatusPayload;

  if (
    !payload ||
    !payload.conversationId ||
    payload.messageSequence === undefined ||
    !payload.status
  ) {
    console.error('Invalid message status payload:', payload);
    return;
  }

  const { conversationId, messageSequence, status } = payload;

  // Get current state to check if this is for the current conversation
  const state = store.getState();
  const currentConversation = state.chat.conversation;

  // Only process updates for the current conversation
  if (currentConversation && currentConversation.id === conversationId) {
    // Find message index for the given sequence number
    const messageIndex = currentConversation.messages.findIndex(
      (msg) => msg.sequence === messageSequence,
    );

    // Update the message status
    if (messageIndex !== -1) {
      store.dispatch(
        updateMessageStatus({
          conversationId,
          messageIndex,
          status,
        }),
      );

      if (status === MessageStatus.Seen) {
        store.dispatch(
          updateThinkingStatus({
            conversationId,
            userMessageSequence: messageSequence,
            thinkingStatus: '',
          }),
        );
      }
    }
  }
}
